export class GeoMarket {
    key!: string;
    name!: string;
}
